export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20flat%20lay%20with%20neutral%20toned%20clothing%20items%20and%20accessories%20arranged%20on%20textured%20cream%20surface%2C%20soft%20natural%20lighting%20from%20window%2C%20desaturated%20warm%20tones%2C%20editorial%20product%20photography%2C%20minimalist%20composition%20with%20organic%20arrangement%2C%20elegant%20and%20clean%20aesthetic&width=1600&height=900&seq=cta-fashion-bg-01&orientation=landscape"
          alt="Fashion collection background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-12">
          <div className="lg:max-w-lg">
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              unlock the ultimate pandabuyspreadsheet
            </h2>
          </div>

          <div className="flex flex-col gap-6">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-8 py-4 bg-white text-foreground-900 rounded-full text-base font-semibold hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap w-fit"
            >
              <span>buy it now</span>
              <span className="w-8 h-8 flex items-center justify-center bg-foreground-900 text-white rounded-full">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>

            <p className="text-white/80 text-sm leading-relaxed max-w-xs">
              Thousands of curated items<br />
              Updated weekly for global shoppers
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}